'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgNavFunctions = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "m6.572 12 4.545 4.545-3.535 3.537L2 14.5v-5L9.5 2h5l1.035 1.035L6.572 12Z" }),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M12.883 7.455 16.42 3.92 22 9.5v5L14.5 22h-5l-1.035-1.035L17.428 12l-4.545-4.545Z" })
);

module.exports = SvgNavFunctions;
//# sourceMappingURL=NavFunctions.cjs.js.map
